const initialState = {
  requestingFetchPackaging: false,
  successfulFetchPackaging: false,
  errorFetchPackaging: false,
  packaging: null,
  requestingCreatePackaging: false,
  successfulCreatePackaging: false,
  errorsCreatePackaging: false,
  requestingReadPackaging: false,
  successfulReadPackaging: false,
  errorsReadPackaging: false,
  rowEdited: null,
  requestingUpdatePackaging: false,
  successfulUpdatePackaging: false,
  errorsUpdatePackaging: false,
  requestingDeletePackaging: false,
  successfulDeletePackaging: false,
  errorsDeletePackaging: false,
  requestingActivatePackaging: false,
  successfulActivatePackaging: false,
  errorsActivatePackaging: false,
  lastFetchParams: null,
};

const packagingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_PACKAGING_REQUEST":
      return {
        ...state,
        lastFetchParams: action.value || state.lastFetchParams,
      };
    case "FETCH_PACKAGING_REQUESTING":
      return {
        ...state,
        requestingFetchPackaging: true,
        successfulFetchPackaging: false,
        errorFetchPackaging: false,
      };
    case "FETCH_PACKAGING_SUCCESS":
      return {
        ...state,
        errorFetchPackaging: false,
        requestingFetchPackaging: false,
        successfulFetchPackaging: true,
        packaging: action.value,
      };
    case "FETCH_PACKAGING_ERROR":
      return {
        ...state,
        errorFetchPackaging: true,
        requestingFetchPackaging: false,
        successfulFetchPackaging: false,
      };
    case "CREATE_PACKAGING_REQUESTING":
      return {
        ...state,
        requestingCreatePackaging: true,
        successfulCreatePackaging: false,
        errorsCreatePackaging: false,
      };
    case "CREATE_PACKAGING_SUCCESS":
      return {
        ...state,
        errorsCreatePackaging: false,
        requestingCreatePackaging: false,
        successfulCreatePackaging: true,
      };
    case "CREATE_PACKAGING_ERROR":
      return {
        ...state,
        errorsCreatePackaging: true,
        requestingCreatePackaging: false,
        successfulCreatePackaging: false,
      };
    case "READ_PACKAGING_REQUESTING":
      return {
        ...state,
        requestingReadPackaging: true,
        successfulReadPackaging: false,
        errorsReadPackaging: false,
      };
    case "READ_PACKAGING_SUCCESS":
      return {
        ...state,
        errorsReadPackaging: false,
        requestingReadPackaging: false,
        successfulReadPackaging: true,
        rowEdited: action.value,
      };
    case "READ_PACKAGING_ERROR":
      return {
        ...state,
        errorsReadPackaging: true,
        requestingReadPackaging: false,
        successfulReadPackaging: false,
      };
    case "UPDATE_PACKAGING_REQUESTING":
      return {
        ...state,
        requestingUpdatePackaging: true,
        successfulUpdatePackaging: false,
        errorsUpdatePackaging: false,
      };
    case "UPDATE_PACKAGING_SUCCESS":
      return {
        ...state,
        errorsUpdatePackaging: false,
        requestingUpdatePackaging: false,
        successfulUpdatePackaging: true,
      };
    case "UPDATE_PACKAGING_ERROR":
      return {
        ...state,
        errorsUpdatePackaging: true,
        requestingUpdatePackaging: false,
        successfulUpdatePackaging: false,
      };
    case "DELETE_PACKAGING_REQUESTING":
      return {
        ...state,
        requestingDeletePackaging: true,
        successfulDeletePackaging: false,
        errorsDeletePackaging: false,
      };
    case "DELETE_PACKAGING_SUCCESS":
      return {
        ...state,
        errorsDeletePackaging: false,
        requestingDeletePackaging: false,
        successfulDeletePackaging: true,
      };
    case "DELETE_PACKAGING_ERROR":
      return {
        ...state,
        errorsDeletePackaging: true,
        requestingDeletePackaging: false,
        successfulDeletePackaging: false,
      };
    case "ACTIVATE_PACKAGING_REQUESTING":
      return {
        ...state,
        requestingActivatePackaging: true,
        successfulActivatePackaging: false,
        errorsActivatePackaging: false,
      };
    case "ACTIVATE_PACKAGING_SUCCESS":
      return {
        ...state,
        errorsActivatePackaging: false,
        requestingActivatePackaging: false,
        successfulActivatePackaging: true,
      };
    case "ACTIVATE_PACKAGING_ERROR":
      return {
        ...state,
        errorsActivatePackaging: true,
        requestingActivatePackaging: false,
        successfulActivatePackaging: false,
      };
    case "RESET_PACKAGING_FORM":
      return {
        ...state,
        requestingCreatePackaging: false,
        successfulCreatePackaging: false,
        errorsCreatePackaging: false,
        requestingReadPackaging: false,
        successfulReadPackaging: false,
        errorsReadPackaging: false,
        rowEdited: null,
        requestingUpdatePackaging: false,
        successfulUpdatePackaging: false,
        errorsUpdatePackaging: false,
        requestingDeletePackaging: false,
        successfulDeletePackaging: false,
        errorsDeletePackaging: false,
        requestingActivatePackaging: false,
        successfulActivatePackaging: false,
        errorsActivatePackaging: false,
      };
    default:
      return state;
  }
};

export default packagingReducer;
